export { default as BasicInfo } from './BasicInfo';
